// extracted by mini-css-extract-plugin
export default {"root_ind":"root_ind___BbNAg"};